"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__define = exports.__request = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _state = require("./state");

require("./interface");

var __sleep = function __sleep(sec) {
  return new Promise(function (r, j) {
    setTimeout(r, sec);
    false && j();
  });
};

var __waitingForBridgeReady =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (window.hasOwnProperty('__bridge_ready')) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return __sleep(10);

          case 3:
            _context.next = 0;
            break;

          case 5:
            (0, _state.__log)('bridge ready', window['__DEV__']);
            _context.next = 8;
            return new Promise(function (r, j) {
              window.__bridge_ready(function (req, def) {
                r({
                  req: req,
                  def: def
                });
              });

              false && j();
            });

          case 8:
            return _context.abrupt("return", _context.sent);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function __waitingForBridgeReady() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 处理参数中的function
 * server端需要执行桥的sendScriptCallback
 */


var __function_callbacks = {
  callbacks: {},
  offset: 1,
  trigger: function trigger(off, args) {
    console.log(off, args);
    __function_callbacks.callbacks[off] && __function_callbacks.callbacks[off].apply(null, args);
    delete __function_callbacks.callbacks[off];
  },
  filter: function filter(params) {
    //初始化回调存储
    window.ijsbridge_callbacks || (window.ijsbridge_callbacks = __function_callbacks);

    if (Array.isArray(params)) {
      for (var i in params) {
        params[i] = __function_callbacks.filter(params[i]);
      }

      return params;
    }

    if (params && (0, _typeof2["default"])(params) == 'object') {
      for (var _i in params) {
        params[_i] = __function_callbacks.filter(params[_i]);
      }

      return params;
    }

    if (typeof params == 'function') {
      __function_callbacks.offset++;
      __function_callbacks.callbacks[__function_callbacks.offset] = params;
      params = __function_callbacks.offset;
    }

    return params;
  }
};
/**
 * 请求原生接口
 * @param api 
 * @param params 
 */

var __request =
/*#__PURE__*/
function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(api, params) {
    var bridge;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            (0, _state.__log)((0, _state.__get_mode)(), ' call native __request', api, params);
            _context2.next = 3;
            return __waitingForBridgeReady();

          case 3:
            bridge = _context2.sent;
            //转换参数重的function
            params = __function_callbacks.filter(params);
            _context2.next = 7;
            return new Promise(function (r, j) {
              bridge.req(api, params, function (err, result) {
                (0, _state.__log)((0, _state.__get_mode)(), ' native __request result', err, result);
                r({
                  err: err,
                  result: result
                });
              });
            });

          case 7:
            return _context2.abrupt("return", _context2.sent);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function __request(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * 定义本地接口
 */


exports.__request = __request;

var __define =
/*#__PURE__*/
function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee3(api, cb) {
    var bridge;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            (0, _state.__log)((0, _state.__get_mode)(), ' call native __define', api);
            _context3.next = 3;
            return __waitingForBridgeReady();

          case 3:
            bridge = _context3.sent;
            bridge.def(api, function (err, result) {
              (0, _state.__log)((0, _state.__get_mode)(), ' call native __define', err, result);
              cb(err, result);
            });
            return _context3.abrupt("return", true);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function __define(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.__define = __define;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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